import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, Layout, Space, Typography } from "antd";
import { useAuthenticatedFetch } from "@/Api/Axios";
import { resetPasswordFormFields, resetPasswordInitialValues } from "@/Assets/Mocks/ResetPassword.mock.js";
import CommonForm from "@/Components/Common/CommonForm";
import { useAuth } from "@/Context/AuthContext";
import { ToastContext } from "@/Context/ToastContext";

const { Text, Title } = Typography;
const { Content } = Layout;

export const ResetPassword = () => {
  const resetPasswordToken = new URLSearchParams(window.location.search).get("token");
  const email = new URLSearchParams(window.location.search).get("email");
  const [loading, setLoading] = useState(true);
  const [verificationSuccess, setVerificationSuccess] = useState(false);
  const fetch = useAuthenticatedFetch();
  const navigate = useNavigate();
  const { logout, login } = useAuth();
  const { showToast } = useContext(ToastContext);

  useEffect(() => {
    const checkVerification = async () => {
      const res = await fetch.get(`/verifyResetToken/${resetPasswordToken}/${email}`);
      setLoading(false);

      if (res.data.resetVerified) {
        setVerificationSuccess(true);
      } else {
        setVerificationSuccess(false);
      }
    };
    checkVerification();
  }, []);

  const handleSubmit = async (e) => {
    const res = await fetch.post("/password", { email: email, ...e });
    if (res.data) {
      showToast("Password updated successfully");
      navigate("/login");
    }
  };

  if (verificationSuccess) {
    return (
      <Layout style={{ minHeight: "100vh" }}>
        <Content style={{ padding: "24px", display: "flex", justifyContent: "center", alignItems: "center" }}>
          <div className="public-page" style={{ width: "35%", minWidth: "320px" }}>
            <Card>
              <Space direction="vertical" size="large" style={{ width: "100%" }}>
                <Title level={2} style={{ textAlign: "center", color: "#666", fontWeight: "bold", margin: 0 }}>
                  Reset Password
                </Title>
                <Card>
                  <Space direction="vertical" size="middle" style={{ width: "100%" }}>
                    <CommonForm
                      onSubmit={handleSubmit}
                      initialValues={resetPasswordInitialValues}
                      formFields={resetPasswordFormFields}
                      isSave={true}
                      label="Reset"
                    />
                  </Space>
                </Card>
              </Space>
            </Card>
          </div>
        </Content>
      </Layout>
    );
  }
};
